import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';
import { env } from './env';

let cached: SupabaseClient<Database> | null = null;

/**
 * Client Supabase typé via la régénération `gen types` du projet de prod.
 * Toutes les requêtes héritent du typage des tables et RPCs déclarés
 * dans `src/types/database.ts`.
 */
export function supabase(): SupabaseClient<Database> {
  if (cached) return cached;
  cached = createClient<Database>(env.supabase.url, env.supabase.anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return cached;
}
